import React from 'react';
import DevicesOutlinedIcon from '@material-ui/icons/DevicesOutlined';
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';

const ConteudoQuemSomosA = () => (
  <div className="page-contato" style={{fontSize: 16, backgroundColor: '#ffffff'}}>
    <section className="gv-section">
      <div className="section-content">
        <h2 className="gv-title">A Samatur</h2>
        <p className="txt-item">A Samatur, com razão social Expresso Transportes Turismo e Eventos Ltda (CNPJ 04.768.381/000104), atua desde 6 de novembro de 2001 em Brasília - DF, especializada em transporte interestadual de passageiros com itinerário fixo.</p>        
        <h2 className="gv-title" style={{ marginTop: 24 }}>Presença e Abrangência</h2>
        <p className="txt-item">Baseada no Setor de Materiais de Construção, Ceilândia - Brasília, nossa empresa conta também com filiais estratégicas em Águas Lindas de Goiás (iniciada em maio de 2015), Araguaína (desde agosto de 2019) e Grajaú/MA (desde janeiro de 2018). Essa rede reforça nosso compromisso com o transporte eficiente entre o Distrito Federal e o Maranhão, integrando rotas, pessoas e culturas.</p>
        <h2 className="gv-title" style={{ marginTop: 24 }}>Frota e Segurança</h2>
        <p className="txt-item">Nossa frota segue rígido programa de manutenção preventiva e corretiva, equipada com os mais modernos dispositivos de segurança. Nossos motoristas são selecionados e altamente treinados para garantir conforto e bem-estar ao longo de cada viagem.</p>
        <h2 className="gv-title" style={{ marginTop: 24 }}>Missão e Valores</h2>        
        <p className="txt-item"><strong>- Confiabilidade:</strong> compromisso com horários, manutenção e rotas seguras.</p>
        <p className="txt-item"><strong>- Segurança:</strong> estrutura e equipe preparadas para priorizar vidas.</p>
        <p className="txt-item"><strong>- Personalização regional:</strong> atenção às necessidades dos passageiros que viajam entre Brasília, Goiás e o Maranhão.</p>
        <p className="txt-item"><strong>- Experiência:</strong> atuação consolidada ao longo de mais de duas décadas, de forma séria e comprometida.</p>
        <h2 className="gv-title" style={{ marginTop: 24 }}>Por que viajar com a Samatur?</h2>
        <p className="txt-item"><strong>1. Especialização interestadual</strong> - Rota fixa entre Brasília e localidades no Maranhão, com longa tradição no setor.</p>
        <p className="txt-item"><strong>2. Cobertura regional robusta</strong> - Com filiais em pontos logísticos estratégicos, garantimos acessibilidade ampla e suporte eficiente.</p>
        <p className="txt-item"><strong>3. Padrões de excelência</strong> - Frota moderna, motoristas experientes, e foco constante em conforto e segurança.</p>
        <h2 className="gv-title" style={{ marginTop: 24 }}>Implantação de Rotas</h2>
        <p className="txt-item">Atualmente oferecemos rotas regulares entre o Distrito Federal e o Maranhão, passando por polos como Grajaú - com embarque e desembarque no Terminal Rodoviário local - e diversos outros pontos alinhados à demanda dos passageiros.</p>
        
        <section className="gv-cards" style={{ marginTop: 50 }}>
          <div className="gv-cards-wrapper">
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <DevicesOutlinedIcon className="box-item-icon"></DevicesOutlinedIcon>
                  <p>Tecnologia</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Descomplicamos o jeito antigo complicado de comprar uma passagem!</p>
                </span>
              </div>
            </div>
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <EmojiObjectsOutlinedIcon className="box-item-icon"></EmojiObjectsOutlinedIcon>
                  <p>Inovação</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Inovamos em um mercado promissor, tecnologia simples, aplicada e segura para você, sua família e amigos.</p>
                </span>
              </div>
            </div>
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <PeopleAltOutlinedIcon className="box-item-icon"></PeopleAltOutlinedIcon>
                  <p>Relacionamento</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Pensamos em você muito mais que um simples cliente, temos você como parte de nossa empresa, sem você não teríamos motivos de estar aqui!</p>
                </span>
              </div>
            </div>
            <div className="gv-card gv-card-qs">
              <div className="nome-card">
                <span className="box-item-card-title">
                  <TrendingUpOutlinedIcon className="box-item-icon"></TrendingUpOutlinedIcon>
                  <p>Agilidade</p>
                  <div className="divider"/>
                </span>
                <span className="box-item-card-info">
                  <p>Rápido e descomplicado. Clicou, comprou, viajou!</p>
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
)

export default ConteudoQuemSomosA

